module.exports = __webpack_public_path__ + "static/media/reply_waiting.6ddafe68.png";